import { render } from "./MoreElements.vue?vue&type=template&id=66f9e610"
import script from "./MoreElements.vue?vue&type=script&lang=js"
export * from "./MoreElements.vue?vue&type=script&lang=js"
script.render = render

export default script